import { BOOLEAN_VALUE, FormFieldsData } from 'framework/form';
import { BillingType, ENGAGEMENT_TYPE, PROJECT_SCENARIO, PROJECT_SCENARIO_OPTIONS } from 'domain/shared/newProject';

export const getDefaultScenario = (
  isContractRenewal?: string,
  engagementType?: string,
): keyof typeof PROJECT_SCENARIO_OPTIONS | null => {
  if (isContractRenewal !== BOOLEAN_VALUE.YES) {
    return null;
  }

  switch (engagementType) {
    case ENGAGEMENT_TYPE.SCOPE_BASED:
    case ENGAGEMENT_TYPE.DESIGN_AND_FEASIBILITY:
      return PROJECT_SCENARIO.FIXED_SCOPE;
    case ENGAGEMENT_TYPE.DEDICATED_CAPACITY:
    case ENGAGEMENT_TYPE.SUPPORT_SERVICES:
      return PROJECT_SCENARIO.DEDICATED_TEAM;
    default:
      return null;
  }
};

export const getProjectScenarioConfiguration = (
  scenario: keyof typeof PROJECT_SCENARIO_OPTIONS | null,
): FormFieldsData => {
  switch (scenario) {
    case PROJECT_SCENARIO.FIXED_SCOPE:
      return {
        project: {
          scenario,
          createDaVinciRedmine: true,
          createNewProject: false,
          engagementType: ENGAGEMENT_TYPE.SCOPE_BASED,
        },
        budget: {
          billingType: BillingType.MILESTONE,
          startDate: null,
          softStartDate: null,
          endDate: null,
          extendedEndDate: null,
        },
      };
    case PROJECT_SCENARIO.DEDICATED_TEAM:
      return {
        project: {
          scenario,
          createDaVinciRedmine: true,
          createNewProject: false,
          engagementType: ENGAGEMENT_TYPE.DEDICATED_CAPACITY,
        },
        budget: {
          billingType: null,
          startDate: null,
          softStartDate: null,
          endDate: null,
          extendedEndDate: null,
        },
      };
    case PROJECT_SCENARIO.NEW_PROJECT:
      return {
        project: {
          scenario,
          createDaVinciRedmine: true,
          createNewProject: true,
          engagementType: null,
        },
        budget: {
          billingType: null,
          startDate: null,
          softStartDate: null,
          endDate: null,
          extendedEndDate: null,
        },
      };
    case PROJECT_SCENARIO.REPLACEMENT:
      return {
        project: {
          scenario,
          createDaVinciRedmine: false,
          createNewProject: false,
          engagementType: null,
        },
        budget: {
          billingType: null,
          startDate: null,
          softStartDate: null,
          endDate: null,
          extendedEndDate: null,
        },
      };
    default:
      return {
        project: {
          scenario,
          createDaVinciRedmine: null,
          createNewProject: null,
          engagementType: null,
        },
        budget: {
          billingType: null,
          startDate: null,
          softStartDate: null,
          endDate: null,
          extendedEndDate: null,
        },
      };
  }
};
